import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { getHaldorAssignments, getMicrosoftEducationAssignments, clearLatestAssignments, getLatestHaldorAssignments, getLatestMicrosoftEducationAssignments } from 'actions/assignments';
import { clearSearchResults, searchHaldorAssignmentsInGroup, searchMicrosoftAssignmentsInGroup, searchAssignment } from 'actions/search';
import { ColorLabel, ColorLabelContainer, Spinner } from 'UI';
import { Search } from 'UI/Inputs';
import { Tabs, Tab, translate } from '@haldor/ui';
import FromNow from 'components/Presentation/Date/FromNow';
import './AssignmentSelect.scss';

var AssignmentSelect = /*#__PURE__*/function (_Component) {
  _inherits(AssignmentSelect, _Component);

  var _super = _createSuper(AssignmentSelect);

  function AssignmentSelect(props) {
    var _this;

    _classCallCheck(this, AssignmentSelect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.setState({
        loadingLatest: true
      });

      var promises = [];

      if (_this.props.section != null) {
        if (_this.props.services.haldor) {
          promises.push(_this.props.getLatestHaldorAssignments(_this.props.section.graphId));
        }

        if (_this.props.services.microsoft) {
          promises.push(_this.props.getLatestMicrosoftEducationAssignments(_this.props.section.graphId));
        }
      } else {
        if (_this.props.services.haldor) {
          promises.push(_this.props.getHaldorAssignments());
        }

        if (_this.props.services.microsoft) {
          promises.push(_this.props.getMicrosoftEducationAssignments());
        }
      }

      Promise.all(promises).then(function () {
        _this.setState({
          loadingLatest: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (_this.props.section == null && nextProps.section != null && _this.state.loadingLatest == false) {
        _this.setState({
          loadingLatest: true
        });

        var promises = [];

        if (_this.props.services.microsoft) {
          promises.push(_this.props.getLatestHaldorAssignments(nextProps.section.graphId));
        }

        if (_this.props.services.haldor) {
          promises.push(_this.props.getLatestMicrosoftEducationAssignments(nextProps.section.graphId));
        }

        Promise.all(promises).then(function () {
          _this.setState({
            loadingLatest: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearSearchResults();

      _this.props.clearLatestAssignments();
    });

    _defineProperty(_assertThisInitialized(_this), "assignmentFilter", function (assignment) {
      var filterResults = _this.props.filterResults;

      if (assignment.status == 'ASSIGNMENT_DELETED') {
        return true;
      }

      if (filterResults != null && filterResults.length > 0) {
        var found = filterResults.find(function (id) {
          return id == assignment.id;
        });
        return found != null;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (value) {
      _this.setState({
        loading: true
      });

      var promises = [];

      if (_this.props.section != null) {
        if (_this.props.services.microsoft) {
          promises.push(_this.props.searchMicrosoftAssignmentsInGroup(value.query, _this.props.section.graphId));
        }

        if (_this.props.services.haldor) {
          promises.push(_this.props.searchHaldorAssignmentsInGroup(value.query, _this.props.section.graphId));
        }
      } else {
        if (_this.props.services.haldor) {
          promises.push(_this.props.searchAssignment(value.query));
        }
      }

      Promise.all(promises).then(function () {
        _this.setState({
          loading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderAssignment", function (assignment) {
      if (assignment.title == '') return null;
      if (_this.assignmentFilter(assignment)) return null;
      var courses = [];

      if (assignment.selectedCourses != null && _this.props.section != null) {
        var courseIds = assignment.selectedCourses.split(";");
        courseIds.forEach(function (id) {
          var findCourse = _this.props.section.courses.find(function (t) {
            return t.id == id;
          });

          if (findCourse != null) {
            courses.push(findCourse);
          }
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "assignment",
        key: 'selected-assignment-haldor-' + assignment.id,
        onClick: function onClick(e) {
          return _this.onSelect(assignment);
        }
      }, courses.length > 0 ? /*#__PURE__*/React.createElement(ColorLabelContainer, {
        collapse: true,
        inline: true,
        style: {
          position: 'relative',
          top: 2,
          marginRight: '0.5rem'
        }
      }, courses.map(function (course) {
        return /*#__PURE__*/React.createElement(ColorLabel, {
          key: course.id,
          color: course.colorCode,
          tooltip: course.title
        });
      })) : null, assignment.title, assignment.section != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, assignment.section.title) : null, assignment.dueDate != null ? /*#__PURE__*/React.createElement(FromNow, null, assignment.dueDate) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderTeamsAssignment", function (assignment) {
      if (assignment.displayName == '') return null;
      if (_this.assignmentFilter(assignment)) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "assignment",
        key: 'selected-assignment-' + assignment.id,
        onClick: function onClick(e) {
          return _this.onSelect(assignment);
        }
      }, assignment.displayName, assignment.reference != null && assignment.reference.section != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta"
      }, assignment.reference.section.title) : null, assignment.dueDateTime != null ? /*#__PURE__*/React.createElement(FromNow, null, assignment.dueDateTime) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (assignment) {
      if (_this.props.onSelect) {
        _this.props.onSelect(assignment);
      }
    });

    _this.state = {
      loading: false,
      loadingLatest: false
    };
    return _this;
  }

  _createClass(AssignmentSelect, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          latestMicrosoftAssignments = _this$props.latestMicrosoftAssignments,
          latestHaldorAssignments = _this$props.latestHaldorAssignments,
          includeAssignmentsWithPlans = _this$props.includeAssignmentsWithPlans,
          teacherAssignments = _this$props.teacherAssignments,
          teacherTeamsAssignments = _this$props.teacherTeamsAssignments;
      var latest = [];

      if (this.props.section != null) {
        if (includeAssignmentsWithPlans != null && includeAssignmentsWithPlans == false) {
          if (latestHaldorAssignments != null && latestHaldorAssignments != '') {
            latest.push.apply(latest, _toConsumableArray(latestHaldorAssignments.filter(function (t) {
              return t.plans.length == 0;
            })));
          }

          if (latestMicrosoftAssignments != null) {
            latest.push.apply(latest, _toConsumableArray(latestMicrosoftAssignments));
          }
        } else {
          if (latestMicrosoftAssignments != null) {
            latest.push.apply(latest, _toConsumableArray(latestMicrosoftAssignments));
          }

          if (latestHaldorAssignments != null) {
            latest.push.apply(latest, _toConsumableArray(latestHaldorAssignments));
          }
        }
      } else {
        latest.push.apply(latest, _toConsumableArray(teacherAssignments));
        latest.push.apply(latest, _toConsumableArray(teacherTeamsAssignments));
      }

      latest.sort(function (a, b) {
        var aDate,
            bDate = null;

        if (a.created != null) {
          aDate = a.created;
        } else {
          aDate = a.createdDateTime;
        }

        if (b.created != null) {
          bDate = b.created;
        } else {
          bDate = b.createdDateTime;
        }

        return moment.utc(bDate).local().unix() - moment.utc(aDate).local().unix();
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "container assignment-selector",
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/React.createElement(Search, {
        onSubmit: this.onSearch,
        loading: this.state.loading,
        lengthLimit: 3
      }), /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('latest'),
        route: "latest"
      }, this.state.loadingLatest ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : null, latest.map(function (assignment) {
        if (assignment.displayName != null) return _this2.renderTeamsAssignment(assignment);
        var inLatestMicrosoftAssignments = latestMicrosoftAssignments === null || latestMicrosoftAssignments === void 0 ? void 0 : latestMicrosoftAssignments.findIndex(function (_assignment) {
          return _assignment.id == assignment.externalID;
        });
        var inTeacherTeamsAssignments = teacherTeamsAssignments === null || teacherTeamsAssignments === void 0 ? void 0 : teacherTeamsAssignments.find(function (_assignment) {
          return _assignment.id == assignment.externalID;
        });
        if (inLatestMicrosoftAssignments != null && inLatestMicrosoftAssignments > -1) return null;
        if (inTeacherTeamsAssignments != null) return null;
        return _this2.renderAssignment(assignment);
      })), this.props.searchAssignmentsNoGroup != null && this.props.searchAssignmentsNoGroup.length > 0 ? /*#__PURE__*/React.createElement(Tab, {
        title: "Haldor Education",
        route: "haldor"
      }, this.props.searchAssignmentsNoGroup.map(function (assignment) {
        var _this2$props$microsof;

        var inMicrosoftTeamsResults = (_this2$props$microsof = _this2.props.microsoftAssignments) === null || _this2$props$microsof === void 0 ? void 0 : _this2$props$microsof.findIndex(function (_assignment) {
          return _assignment.id == assignment.externalID;
        });
        if (inMicrosoftTeamsResults != null && inMicrosoftTeamsResults > -1) return null;
        return _this2.renderAssignment(assignment);
      })) : null, this.props.microsoftAssignments != null && this.props.microsoftAssignments.length > 0 ? /*#__PURE__*/React.createElement(Tab, {
        title: "Microsoft Assignments",
        route: "microsoft"
      }, this.props.microsoftAssignments.map(function (assignment) {
        return _this2.renderTeamsAssignment(assignment);
      })) : null, this.props.haldorAssignments != null && this.props.haldorAssignments.length > 0 ? /*#__PURE__*/React.createElement(Tab, {
        title: "Haldor Education",
        route: "haldor"
      }, this.props.haldorAssignments.map(function (assignment) {
        var _this2$props$microsof2;

        var inMicrosoftTeamsResults = (_this2$props$microsof2 = _this2.props.microsoftAssignments) === null || _this2$props$microsof2 === void 0 ? void 0 : _this2$props$microsof2.findIndex(function (_assignment) {
          return _assignment.id == assignment.externalID;
        });
        if (inMicrosoftTeamsResults != null && inMicrosoftTeamsResults > -1) return null;
        return _this2.renderAssignment(assignment);
      })) : null, this.props.assignments != null && this.props.assignments.length > 0 ? /*#__PURE__*/React.createElement(Tab, {
        title: "Haldor Education",
        route: "assignments"
      }, this.props.assignments.map(function (assignment) {
        return _this2.renderAssignment(assignment);
      })) : null));
    }
  }]);

  return AssignmentSelect;
}(Component);

function mapStateToProps(state) {
  return {
    assignments: state.Search.assignments,
    haldorAssignments: state.Search.haldorAssignments,
    microsoftAssignments: state.Search.microsoftAssignments,
    latestMicrosoftAssignments: state.assignments.latestMicrosoftAssignments,
    latestHaldorAssignments: state.assignments.latestHaldorAssignments,
    services: state.Services.availableServices,
    translate: translate(state.Languages.translations),
    teacherAssignments: state.assignments.assignments,
    teacherTeamsAssignments: state.assignments.teamsAssignments,
    searchAssignmentsNoGroup: state.assignments.search_results
  };
}

export default connect(mapStateToProps, {
  getHaldorAssignments: getHaldorAssignments,
  getMicrosoftEducationAssignments: getMicrosoftEducationAssignments,
  searchHaldorAssignmentsInGroup: searchHaldorAssignmentsInGroup,
  searchMicrosoftAssignmentsInGroup: searchMicrosoftAssignmentsInGroup,
  getLatestHaldorAssignments: getLatestHaldorAssignments,
  getLatestMicrosoftEducationAssignments: getLatestMicrosoftEducationAssignments,
  clearSearchResults: clearSearchResults,
  clearLatestAssignments: clearLatestAssignments,
  searchAssignment: searchAssignment
})(AssignmentSelect);